/* eslint-env browser */
/* eslint-disable no-param-reassign */
import React from 'react';
import PropTypes from 'prop-types';
import DropdownMultiItemComponent from './DropdownMultiItemComponent';

class DropdownMultiComponent extends React.Component {
  constructor(props) {
    super(props);

    const containers = [];

    containers.push({
      ID: 0,
      Name: props.grouping.Name,
      Associations: [],
      Multi: false,
    });

    props.grouping.AssociationContainers.forEach((c) => {
      containers.push({
        ID: c.ID,
        Name: c.Name,
        Associations: c.Associations,
        Multi: true,
      });
    });

    this.state = {
      containers,
      selected: 0,
      assocs: !sessionStorage.getItem(`gym-multi-${props.index}`) ? [] : JSON.parse(sessionStorage.getItem(`gym-multi-${props.index}`)),
    };

    this.handleChange = this.handleChange.bind(this);
    this.activate = this.activate.bind(this);
    this.setAssocs = this.setAssocs.bind(this);
  }

  handleChange(key) {
    const { selected } = this.state;
    const { setActive, active, index } = this.props;
    if (key > 0) {
      this.setState({
        selected: key === selected ? 0 : key,
      });
    } else {
      setActive(index === active ? 0 : index);
    }
  }

  setAssocs(assocs) {
    const { assocs: stAssocs } = this.state;
    // const { index } = this.props;
    assocs.forEach((a) => {
      if (stAssocs.filter((x) => x.ID === a.ID).length === 0) {
        stAssocs.push(a);
      }
    });
    this.setState({
      assocs: stAssocs,
    }, () => {
      // sessionStorage.setItem(`gym-multi-${index}`, JSON.stringify(stAssocs));
    });
  }

  activate() {
    const { assocs } = this.state;
    const {
      setSelectedSubjects,
      dropDownSearch,
      setActive,
    } = this.props;
    setSelectedSubjects(assocs);
    dropDownSearch(assocs.filter((x) => x.Checked).map((x) => x.ID),
      assocs.filter((x) => !x.Checked).map((x) => x.ID));
    setActive(0);
  }

  render() {
    const { containers, selected, assocs } = this.state;
    const {
      reset,
      index,
      active,
    } = this.props;
    const assocNodes = containers.slice(1).map((c, i) => {
      const key = i;
      return (
        <DropdownMultiItemComponent
          key={key}
          container={c}
          selected={c.ID === selected}
          handleChange={this.handleChange}
          reset={reset}
          setAssocs={this.setAssocs}
        />
      );
    });
    let classNames = 'gym-dropdown resetlist';
    if (index === active) {
      classNames += ' open';
    }

    return (
      <ul className={classNames}>
        <DropdownMultiItemComponent
          container={containers[0]}
          selected
          handleChange={this.handleChange}
          reset={reset}
          setAssocs={this.setAssocs}
        />
        {(() => {
          if (assocs.length > 0) {
            return (
              <li className="multi activate">
                <div className="row">
                  <div className="column large-6 medium-6 small-12">
                    <button
                      type="button"
                      className="button"
                      onClick={(e) => {
                        e.preventDefault();
                        this.activate();
                      }}
                    >
                      <strong>
                        Anvend
                      </strong>
                    </button>
                  </div>
                  <div className="column large-6 medium-6 small-12">
                    <button
                      type="button"
                      className="button float-right"
                      onClick={() => {
                        assocs.forEach((a) => {
                          a.Checked = false;
                        });
                        this.setAssocs(assocs);
                        this.activate();
                      }}
                    >
                      Nulstil filter
                    </button>
                  </div>
                </div>
              </li>
            );
          }
          return null;
        })()}
        {assocNodes}
      </ul>
    );
  }
}

DropdownMultiComponent.propTypes = {
  active: PropTypes.number.isRequired,
  dropDownSearch: PropTypes.func.isRequired,
  grouping: PropTypes.shape({
    Active: PropTypes.bool.isRequired,
    AssociationContainers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    DataList: PropTypes.number,
    DataListAssociations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    GroupOrder: PropTypes.number.isRequired,
    ID: PropTypes.number.isRequired,
    List: PropTypes.number.isRequired,
    Name: PropTypes.string.isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  setSelectedSubjects: PropTypes.func.isRequired,
  setActive: PropTypes.func.isRequired,
  reset: PropTypes.bool.isRequired,
};

DropdownMultiComponent.displayName = 'DropdownMultiComponent';
export default DropdownMultiComponent;
